import {createSvgIcon} from '../create-svg-icon';

export const NetworkCellIcon = createSvgIcon(
  <path d="M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z" />
, 'NetworkCellOutlined');
